import { render, staticRenderFns } from "./ModuleModal.component.vue?vue&type=template&id=1c54c81b&"
import script from "./ModuleModal.component.vue?vue&type=script&lang=js&"
export * from "./ModuleModal.component.vue?vue&type=script&lang=js&"
import style0 from "./ModuleModal.component.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports